export default "__VITE_ASSET__BWAvsd8H__"